import { withRouter } from 'react-router-dom'
import React from 'react';
import { withTranslation } from 'react-i18next';

class EmailView extends React.Component {

    render() {
        return (
            <div>
            </div>
        );
    }
}


export default withRouter(withTranslation()(EmailView));


// WEBPACK FOOTER //
// ./src/containers/Email/EmailView.js